import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import { Loading as RevisionHistoryLoading } from '@/_containers/revision-history/loading';
import { Loading as ViewLogLoading } from '@/_containers/view-logs/loading';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} />

      <Container>
        <LeftSection forceFullWidth>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withIcon={false} />
            <FormLayout>
              <InputSkeleton className="col-span-12 h-24" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton />
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withRightSlot />
            <div className="mt-4 flex flex-col gap-3">
              <InputSkeleton className="h-20 w-full max-w-xl" />
              <InputSkeleton className="h-10 w-full" />
              <InputSkeleton className="h-10 w-full" />
            </div>
          </CardContainer>
        </LeftSection>
      </Container>

      <div className="4xl:mx-0 container mt-4 ml-0 w-full min-w-0 px-6">
        <CardContainer>
          <SectionHeadingSkeleton withIcon={false} />
          <div className="mt-6 space-y-3">
            <InputSkeleton className="h-10 w-full" />
            <InputSkeleton className="h-10 w-full" />
            <InputSkeleton className="h-10 w-full" />
            <InputSkeleton className="h-10 w-full" />
          </div>
        </CardContainer>
      </div>

      <div className="4xl:mx-0 container mt-4 ml-0 grid w-full min-w-0 grid-cols-1 gap-4 px-6 md:grid-cols-2">
        <CardContainer bodyClassName="pr-0">
          <RevisionHistoryLoading />
        </CardContainer>
        <CardContainer bodyClassName="pr-0">
          <ViewLogLoading />
        </CardContainer>
      </div>
    </ContainerLayout>
  );
}
